import { Elements } from "@stripe/react-stripe-js";
import styles from "./styles.module.scss";
import { FeaturesList } from "../featuresList";
import { PlanItem } from "./components/planItem";
import { useDispatch, useSelector } from "react-redux";
import { loadStripe } from "@stripe/stripe-js";
import { Spinner } from "@common/spinner";
import { PaymentOptions } from "./components/paymentOptions";
import { useDiscount } from "@hooks/useDiscount";
import { StripeElementsProvider } from "src/routes/containers/paywalls/shared/components/plan/stripeElementsContext";
import { setActiveUpsalePlan } from "src/redux/slices/plansSlice";

const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_API_KEY
);

export const Plan = ({ idempotencyKey, onSkip, plans, isWalky }) => {
  const dispatch = useDispatch();
  const { isDiscounted } = useDiscount();
  const { activeUpsalePlan: activePlan, isLoading } = useSelector(
    (state) => state.plans
  );

  const isNotLegacyTrial =
    !activePlan?.hasTrial && activePlan?.uiDisplayOptions?.legacyPlan;
  const options = {
    mode: "subscription",
    currency: activePlan?.currency?.toLowerCase() || "usd",
    amount: isNotLegacyTrial
      ? activePlan?.priceAmount
      : activePlan?.trialPriceAmount || 100,
    appearance: {
      variables: {
        borderRadius: "9999px",
        width: "100%",
      },
    },
  };

  return !isLoading ? (
    <StripeElementsProvider>
      <Elements stripe={stripePromise} options={options}>
        <div className={styles.productCards}>
          {plans?.map((plan) => {
            return (
              <PlanItem
                key={plan.id}
                plan={plan}
                isDiscounted={isDiscounted}
                checked={plan.id === activePlan?.id}
                onSelect={() => dispatch(setActiveUpsalePlan(plan))}
                duration={plan.billingPeriodDuration}
                isWalky={isWalky}
              />
            );
          })}
        </div>
        <FeaturesList isWalky={isWalky} />
        <PaymentOptions
          idempotencyKey={idempotencyKey}
          activePlan={activePlan}
          onSkip={onSkip}
          isWalky={isWalky}
        />
      </Elements>
    </StripeElementsProvider>
  ) : (
    <div className={styles.spinner}>
      <Spinner />
    </div>
  );
};
